import React  from 'react';
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import rockoh from "../../assets/Projects/rockoh.png";
import faceDetection from "../../assets/Projects/face-detection.png";
import npm from "../../assets/Projects/npm.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My side <strong className="light-brown">Projects </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rockoh}
              title="Climbing App"
              description="Currently working on my side project RockOh! A climbing app for socializing in gyms, learning from others, sharing and mainly having fun around this magnificent sport. The project is still in development so no source code is available to general public."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={faceDetection}
              title="IaaS for face detection"
              description="Developed a cloud ready architecture (Infrastructure as a Service) through message queueing for face detection using OpenCV. The infrastructure is composed by a web-server, a message broker, a database and N number of workers who will process the images for finding faces in them. "
              link="https://github.com/victorigualada/tfg/blob/main/TFG_VICTOR_FINAL.pdf"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={faceDetection}
              title="NodeJS Tetris"
              description="A tetris app made in Typescript and NodeJS"
              link="https://github.com/victorigualada/oe-tetris"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={npm}
              title="Barrelator"
              description="An npm package Javascript/Typescript barreler for files and assets"
              link="https://www.npmjs.com/package/barrelator"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
